// extracted by mini-css-extract-plugin
export default {"conversationsContainer":"Main_conversationsContainer__CIH21","conversationListContainer":"Main_conversationListContainer__6SRoP","header":"Main_header__h15Zg"};